var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTherapyPlanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3041 18.074H21.9648V22.8483H17.3041V18.074Z",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0638 1.60352H21.7048C21.2618 1.60352 20.9027 1.96262 20.9027 2.40561V5.55174C20.9027 5.99472 21.2618 6.35383 21.7048 6.35383H22.0638C22.5068 6.35383 22.8659 5.99472 22.8659 5.55174V2.40561C22.8659 1.96262 22.5068 1.60352 22.0638 1.60352Z",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57576 1.60352H6.21676C5.77378 1.60352 5.41467 1.96262 5.41467 2.40561V5.55174C5.41467 5.99472 5.77378 6.35383 6.21676 6.35383H6.57576C7.01874 6.35383 7.37785 5.99472 7.37785 5.55174V2.40561C7.37785 1.96262 7.01874 1.60352 6.57576 1.60352Z",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2741 2.71948H20.9021M26.1557 8.80662V26.3541C26.1557 26.6577 25.9779 26.9039 25.7584 26.9039H2.3966C2.17779 26.9039 2 26.6577 2 26.3541M5.41418 2.71948H2.39728C2.17847 2.71948 2 2.96565 2 3.26994V26.3384",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8646 2.71948H25.7728C25.9848 2.71948 26.1557 2.96565 26.1557 3.26994V26.3384M2 8.80662H26.1557",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapyPlanner);
export default __webpack_public_path__ + "static/media/therapyPlanner.21e587cab14746fb31fad7a3191bd131.svg";
export { ForwardRef as ReactComponent };